import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

// https://github.com/nygardk/react-share

import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    TumblrShareButton,
    InstapaperShareButton,
    // HatenaShareButton,
    // LineShareButton,
    // LinkedinShareButton,
    // LivejournalShareButton,
    // MailruShareButton,
    // OKShareButton,
    // PinterestShareButton,
    // PocketShareButton,
    // RedditShareButton,
    // TelegramShareButton,
    // ViberShareButton,
    // VKShareButton,
    // WhatsappShareButton,
    // WorkplaceShareButton
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    TwitterIcon,
    TumblrIcon,
    InstapaperIcon,
    // FacebookMessengerIcon,
    // HatenaIcon,
    // LineIcon,
    // LinkedinIcon,
    // LivejournalIcon,
    // MailruIcon,
    // OKIcon,
    // PinterestIcon,
    // PocketIcon,
    // RedditIcon,
    // TelegramIcon,
    // ViberIcon,
    // VKIcon,
    // WeiboIcon,
    // WhatsappIcon,
    // WorkplaceIcon
} from "react-share";

const SocialBlock = styled.div`
    background-color: white;
    text-align: center;
`;

const SocialIcon = styled.div`
    height: 32px;
    width: 32px;
    display: inline-block;
    border-radius: 50%;   
    margin: 0.5rem; 
    box-shadow: 0.5rem 0.75rem 1.0rem #dddddd;
`;

export class SidebarSocial extends Component {

    static propTypes = {
        url: PropTypes.string.isRequired,
    }

    render() {
        const {text, url} = this.props;
        return <SocialBlock>

            <SocialIcon>
                <EmailShareButton subject={"am chill whale"} body={text} url={url}>
                    <EmailIcon size={32} round={true}/>
                </EmailShareButton>
            </SocialIcon>

            <SocialIcon>
                <FacebookShareButton quote={text} url={url}>
                    <FacebookIcon size={32} round={true}/>
                </FacebookShareButton>
            </SocialIcon>

            <SocialIcon>
                <TwitterShareButton title={text} via={'youknow'} url={url}>
                    <TwitterIcon size={32} round={true}/>
                </TwitterShareButton>
            </SocialIcon>

            <SocialIcon>
                <TumblrShareButton title={text} via={'youknow'} url={url}>
                    <TumblrIcon size={32} round={true}/>
                </TumblrShareButton>
            </SocialIcon>

            <SocialIcon>
                <InstapaperShareButton title={text} via={'youknow'} url={url}>
                    <InstapaperIcon size={32} round={true}/>
                </InstapaperShareButton>
            </SocialIcon>

            {/*{HatenaShareButton}*/}
            {/*{InstapaperShareButton}*/}
            {/*{LineShareButton}*/}
            {/*{LinkedinShareButton}*/}
            {/*{LivejournalShareButton}*/}
            {/*{MailruShareButton}*/}
            {/*{OKShareButton}*/}
            {/*{PinterestShareButton}*/}
            {/*{PocketShareButton}*/}
            {/*{RedditShareButton}*/}
            {/*{TelegramShareButton}*/}
            {/*{ViberShareButton}*/}
            {/*{VKShareButton}*/}
            {/*{WhatsappShareButton}*/}
            {/*{WorkplaceShareButton}*/}
        </SocialBlock>
    }
}

export default SidebarSocial;